<div class="flex min-h-screen w-full flex-auto flex-col">
  <router-outlet />
</div>
